// extracted by mini-css-extract-plugin
export default {"root":"ModalLayout_root__LA8Ra","container":"ModalLayout_container__iW6De","title":"ModalLayout_title__blCWA"};